export enum ProvisioningFieldTypes {
  DYNAMIC_QUESTION = 'dynamic_question',
  REGION = 'region',
  INITIAL_ADMIN = 'initial_admin',
}
export enum ComponentType {
  DROP_DOWN = 'choices',
  TEXT_INPUT = 'string',
}
